import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getListMonsterAddressWalletSuccess,
  getListMonsterAddressWalletFailed,
  GET_LIST_MONSTER_ADDRESS_START,
} from '~/views/app/redux/actions/user'

/**
 * get list monster api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListMonsterAddressApi = (params) => {
  const uri = `/admin/manager-tes-users/${params}/monsters`
  return api.get(uri)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListMonsterAddress(action) {
  try {
    const response = yield call(getListMonsterAddressApi, action?.payload)
    yield put(getListMonsterAddressWalletSuccess(response))

    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getListMonsterAddressWalletFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list monster
 */
export default function* watchGetListMonsterAddress() {
  yield takeLatest(GET_LIST_MONSTER_ADDRESS_START, doGetListMonsterAddress)
}
